/**
 * A generator that partitions the input array into batches with specific count. Useful for "multithreaded" requests
 * @param array An array of items to be partitioned to batches
 * @param range The standard batch size (The batch can be shorter if the amount of items left is lower then this number)
 * @returns
 */
export function* partitioned(array, range) {
    let index = 0;
    let localIndex = 0;
    let batch = [];
    while (true) {
        if (index >= array.length) {
            if (batch.length > 0) {
                const batchCopy = [...batch];
                batch = [];
                yield batchCopy;
            }
            return;
        }
        batch.push(array[index++]);
        if (++localIndex >= range) {
            localIndex = 0;
            const batchCopy = [...batch];
            batch = [];
            yield batchCopy;
        }
    }
}
